import React, {useEffect, useState} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  TextField
} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles'
import CloseIcon from "@mui/icons-material/Close";
import {API_ROOT} from "../../../../baseUrls";

const styles = {
  root: {
  },
  header:{
    display:'flex',
    flexWrap:'wrap-reverse',
    justifyContent:'space-between',
  },
  close:{
    width:'2rem',
    height:'2rem',
    margin:'-0.5rem 0 0 auto',
  },
  folders:{
    display:'flex',
    flexDirection:'column',
    gap:'1.5rem',
    marginBottom:'1.5rem',
  },
  divider:{
    width:'100%',
    backgroundColor:'rgba(0,0,0,0.34)',
    margin: '1.5rem -8px 0 -8px',
  },
  title:{
    flexGrow: 1,
    fontWeight:500,
    display:'flex',
    color:'rgba(0, 0, 0, 0.87)',
    flexWrap:'wrap',
    alignItems:'end',
    gap:'0 0.5rem',
  },
  icons:{
    display: 'flex',
    flexDirection: 'row',
    gap:'0.125rem',
    overflow:'hidden',
    '& > div':{
      display: 'inline-block',
      width:'40px',
      height:'40px',
      flexBasis:'40px',
      flexShrink:'0',
      flexGrow:'0'
    }
  },
  nameText:{
    whiteSpace:'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
    padding:'0 0.5em',
    fontWeight:500,
    lineHeight:'1.36em',
    fontSize:'1.5rem',
  },
  label: {
    fontSize:'0.7225rem',
    fontWeight: 600,
    color: 'rgba(0,0,0,0.54)',
    textTransform: 'uppercase',
    lineHeight: '1.35em',
  },
  edit:{
    display: 'flex',
    flexDirection: 'row',
    gap:'0 0.5rem',
    flexWrap: 'wrap',
  },
  name:{
    flex:1,
    flexBasis:'15em'
  },
  description:{
    flex:3,
    flexBasis:'20em'
  }
};

function FoldersBulkEditDialog(props) {
  const {id, foldersMap, handleSaveFolders, handleClose, open, classes } = props;

  // const updateFolder = (index, folder) => handleFolderChange([...folders.slice(0, index), folder, ...folders.slice(index+1)]);
  const updateFolder = (folder) => setEditFolders({...editFolders, [folder.id]:folder});
  const [editFolders, setEditFolders] = useState(Object.fromEntries(Object.entries(foldersMap).map(
    ([_,f]) => [f.id, {...f, nameOrig: f.nameOrig || f.name}])));
  const folderCount = Object.keys(foldersMap || {}).length;

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
      if(!open){
        return;
      }
      if(!loaded){
        setEditFolders(Object.fromEntries(Object.entries(foldersMap).map(
          ([_,f]) => [f.id, {...f, nameOrig: f.nameOrig || f.name}])));
        setLoaded(true);
      }
      const newMap = {...editFolders};
      let changed = false;
      Object.entries(editFolders).forEach(([id, newItem]) => {
        const prev = newMap[id];
        if(!!prev && newItem.updated_at > prev.updated_at){
          changed = true;
          newMap[id] = {...newItem, nameOrig:newItem.name, name: prev.name, description: prev.description};
        }
      })
      if(changed){
        setEditFolders(newMap);
      }
    },
    // eslint-disable-next-line
    [foldersMap]
  );

  useEffect(() => {
      if(!open){
        setEditFolders({});
      }
      if(loaded && !open){
        setLoaded(false)
      }
    },
    // eslint-disable-next-line
    [open]
  );

  const handleSave = () => {
    handleSaveFolders(Object.entries(editFolders).map(([_, f]) => f));
    handleClose();
  };

  return !open || folderCount === 0 ? null : (
    <Dialog PaperProps={{id:id}}
      // onClose={handleClose}
      open={open}
      fullWidth maxWidth="md"
    >
      <DialogTitle>
        <div className={classes.header}>
          Edit {folderCount > 1 ? `${folderCount} Folders` : 'Folder'}
          <IconButton className={classes.close} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <div id="editFolders" className={classes.folders}>
          {Object.entries(editFolders).map(([id, folder], index) =>
            <div key={folder.id} className={classes.folder}>
              <div className={classes.title}>
                <div className={classes.nameText}>
                  <div className={classes.label}>
                  Folder
                  </div>
                  <span id="editFolderName">{folder.nameOrig}</span> (<span id="editFolderCount">{folder.item_count}</span>)
                </div>
                <div id="editFolderIcons" className={classes.icons}>
                  {Array(Math.min(10,folder.item_count)).fill(1).map((_,i) => (
                    <div key={i} style={{
                      background: `url(${API_ROOT}/mindfiles/${folder.mindfile_id}/folder/${folder.id}/icon/${i}?ts=${new Date(folder.updated_at).getTime()}) 50% 50%/40px no-repeat`,}}
                    />
                  ))}
                </div>
              </div>
              <div className={classes.edit}>
                  <div className={classes.name}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Name"
                    value={folder.name}
                    onChange={(e) => updateFolder({...folder, name: e.target.value})}
                    size="small"
                    margin="normal"
                    InputLabelProps={{shrink: true}}
                  />
                </div>
                <div className={classes.description}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Description"
                    multiline minRows={1} maxRows={4}
                    value={folder.description}
                    onChange={(e) => updateFolder({...folder, description: e.target.value})}
                    size="small"
                    margin="normal"
                    InputLabelProps={{shrink: true}}
                  />
                </div>
              </div>
              {index < folderCount - 1 ? <Divider key={`div_${index}`} className={classes.divider} /> : null}
            </div>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
        >
          Save
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleClose}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default withStyles(styles)(FoldersBulkEditDialog);
